
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as _2257Pqc68DRTviwKS_p6nqwOcvYCg43YOh9hxgcvhD0DNFcMeta } from "/home/runner/work/pornplus/pornplus/frontend/pages/2257.vue?macro=true";
import { default as dmca7QqGjrWVao4R7N0FnktmfqZV2cjMGynrvc_7QbkcsE0Meta } from "/home/runner/work/pornplus/pornplus/frontend/pages/dmca.vue?macro=true";
import { default as indexkualFODmJMITKSdVgf44ZbO0UHWsvHYPMiy_0pSCaSkMeta } from "/home/runner/work/pornplus/pornplus/frontend/pages/index.vue?macro=true";
import { default as terms9ugVegwACccEK5bPU_OIgs_HLlMqdAg6aRc0tUOMiJ4Meta } from "/home/runner/work/pornplus/pornplus/frontend/pages/terms.vue?macro=true";
import { default as privacyrTGqa3s0M4T0ZCjFA3kXh2s_ytafFdiiT0VQTJg2PA0Meta } from "/home/runner/work/pornplus/pornplus/frontend/pages/privacy.vue?macro=true";
import { default as geo_testqeosX_u9SwMxxm5553zT7NeF9jiFftQNogR68FM0tlMMeta } from "/home/runner/work/pornplus/pornplus/frontend/pages/geo_test.vue?macro=true";
import { default as autoIBU_NDDmnMzZThgEoG2YLLyb4xJT72TasVBt4t4gnVEMeta } from "/home/runner/work/pornplus/pornplus/frontend/pages/login/auto.vue?macro=true";
import { default as index6vmxUi8fkTwyK_9qhxSNYi_DlTtnSA_zm6yuXnQotHQMeta } from "/home/runner/work/pornplus/pornplus/frontend/pages/login/index.vue?macro=true";
import { default as indexC3Sr5SXN_PmjGyVTTBYISnG2JKLiQyxPtF82uq8FcHoMeta } from "/home/runner/work/pornplus/pornplus/frontend/pages/sites/index.vue?macro=true";
import { default as indexYwK8ANTJSeZiNSfSd5kGcsXBy_RhGpQTPeNH_1my6E0Meta } from "/home/runner/work/pornplus/pornplus/frontend/pages/models/index.vue?macro=true";
import { default as index_Ui2J3jdpNsHY_kqDVt_rIdSj7lK9ASkiJXzbBkzx8gMeta } from "/home/runner/work/pornplus/pornplus/frontend/pages/series/index.vue?macro=true";
import { default as _91slug_936sMKz3_eYd6iJ9UKObj3oQvi3IFep_o06RdNVF53nB4Meta } from "/home/runner/work/pornplus/pornplus/frontend/pages/sites/[slug].vue?macro=true";
import { default as _91slug_93JOHjtP7h9CRiSKOqN29hpdzRBUgGF7yZ7YTfb5JBUCUMeta } from "/home/runner/work/pornplus/pornplus/frontend/pages/video/[slug].vue?macro=true";
import { default as indexPhn20yhzjC3Zl0lgaB21upwppTXp5VSqBcCb7p1mI9YMeta } from "/home/runner/work/pornplus/pornplus/frontend/pages/members/index.vue?macro=true";
import { default as _91slug_93AgOueyXIKoYgV3SKHOMo0h2ZjBkliEapmiT5AxYxRVwMeta } from "/home/runner/work/pornplus/pornplus/frontend/pages/models/[slug].vue?macro=true";
import { default as _91slug_93ybsK69Li9dGJzlEIWmHZm_grzOW_QMBvVjop8Pg_mywMeta } from "/home/runner/work/pornplus/pornplus/frontend/pages/series/[slug].vue?macro=true";
import { default as indexuFq11J_0OdSOf72cW_axFo_DxATy8N1mewoz2kDtVekMeta } from "/home/runner/work/pornplus/pornplus/frontend/pages/welcome/index.vue?macro=true";
import { default as content_removalzbcP8jN17zojUMLa02OmUAJjXcVAZzQrsstPXA812coMeta } from "/home/runner/work/pornplus/pornplus/frontend/pages/content_removal.vue?macro=true";
import { default as top_45rated4xoSxYGlf5kbitWRGhR7Oe0GMDuKXV5M3N9zvrH_P_kMeta } from "/home/runner/work/pornplus/pornplus/frontend/pages/tours/top-rated.vue?macro=true";
import { default as indexeX_eIUKN6oOMzeTEj7jMvKzThmUFVE_J9LRfAPzULgEMeta } from "/home/runner/work/pornplus/pornplus/frontend/pages/members/deals/index.vue?macro=true";
import { default as indexpSmR8CXh9SW8axSNikmuGPJQOYRjPETL_YtXybAzKz4Meta } from "/home/runner/work/pornplus/pornplus/frontend/pages/members/sites/index.vue?macro=true";
import { default as index_vMdggUkRmWPp_FFPNtNNFihSUbex9rHsv_2SRpJuuMMeta } from "/home/runner/work/pornplus/pornplus/frontend/pages/members/models/index.vue?macro=true";
import { default as indexDpYPPOmqGxJQXQOAz8mS3iBFNZ59r2EuAAn54s84nZoMeta } from "/home/runner/work/pornplus/pornplus/frontend/pages/members/movies/index.vue?macro=true";
import { default as indexLfnGlxalvKLHRqx2aFOEV7VyMPP4_H8YZu4DS7TfuL4Meta } from "/home/runner/work/pornplus/pornplus/frontend/pages/members/offers/index.vue?macro=true";
import { default as indexCtd5FM4bb0KFqabdBltzNvs5dLTImwN7QghPr7cOtsEMeta } from "/home/runner/work/pornplus/pornplus/frontend/pages/members/series/index.vue?macro=true";
import { default as _91slug_93UvYZQRLToPDvL_h9gaY1ETwZWzltCKWV9GhWGQeJsDwMeta } from "/home/runner/work/pornplus/pornplus/frontend/pages/members/sites/[slug].vue?macro=true";
import { default as index_ooUsFvWNbcz5fNxtf4iCKYuUF4siQkkMU8eZX1sAc4Meta } from "/home/runner/work/pornplus/pornplus/frontend/pages/members/account/index.vue?macro=true";
import { default as _91slug_932yvpipxzbWnpY2Q11hbdMdiJ2rMUyFKTd754KAd19uQMeta } from "/home/runner/work/pornplus/pornplus/frontend/pages/members/models/[slug].vue?macro=true";
import { default as _91slug_93HYmZPIfNUVL9mm0_XwBQMHjBdL8AHQY_5O5JZGl7fT8Meta } from "/home/runner/work/pornplus/pornplus/frontend/pages/members/series/[slug].vue?macro=true";
import { default as indexKz3dXBoWZ5raGYs5Ut56GMQUdqgZXR39SM2Ops72nvsMeta } from "/home/runner/work/pornplus/pornplus/frontend/pages/members/upgrade/index.vue?macro=true";
import { default as indexizsvEYaSgToc77395L05OOuuLLRxkDF3hnxOUrbj1zEMeta } from "/home/runner/work/pornplus/pornplus/frontend/pages/members/channels/index.vue?macro=true";
import { default as indexlZv_nTX_W0nVSKL_iu51j4f3PFKUe6cxb6rwBB6RcjgMeta } from "/home/runner/work/pornplus/pornplus/frontend/pages/members/favorites/index.vue?macro=true";
import { default as indexNB6Fmmc_meW5DbA8kz5Av8rDP9FNvUeFFjMfbeyjakYMeta } from "/home/runner/work/pornplus/pornplus/frontend/pages/members/categories/index.vue?macro=true";
import { default as indexKC5EIihmVRTtf4uNT3_nLI8xOk2XtKpTuXF0ERwln20Meta } from "/home/runner/work/pornplus/pornplus/frontend/pages/members/membership/index.vue?macro=true";
import { default as index5TgEnEGNpzP7T3hCzEJgxT99RzyIQHkh7iwOldwi9XsMeta } from "/home/runner/work/pornplus/pornplus/frontend/pages/members/notifications/index.vue?macro=true";
import { default as index2YFMhbfMRRtN6ZQOnlnLhhC3W4kPFUuVzx4t_tERI20Meta } from "/home/runner/work/pornplus/pornplus/frontend/pages/members/subscriptions/index.vue?macro=true";
import { default as index8deCtUegQ88wwFMd4W4r8SJP3QLRUmkx6YfaSg4vGPYMeta } from "/home/runner/work/pornplus/pornplus/frontend/pages/members/channels/[slug]/index.vue?macro=true";
import { default as indexDX3C43A4u9fGPmGLeBvWlTlG2aNrLzZdiZuAwDUYrH0Meta } from "/home/runner/work/pornplus/pornplus/frontend/pages/members/age_verification/index.vue?macro=true";
import { default as _91_91section_93_93rreaHOJXHv2scGIBC3Ujo00osChbsYOehaAVIb_ShbYMeta } from "/home/runner/work/pornplus/pornplus/frontend/pages/members/video/[slug]/[[section]].vue?macro=true";
import { default as index3YQ0txcx8YkIl6L5n49Vwa4bDYP6SYjHRqOF6m5UKAsMeta } from "/home/runner/work/pornplus/pornplus/frontend/pages/members/video/[slug]/pictures/index.vue?macro=true";
import { default as indexAGSMX5S6VQm0Gi0xd_gtwbpmtd12wg3ksdoI14uOJVkMeta } from "/home/runner/work/pornplus/pornplus/frontend/pages/members/channels/[slug]/[release]/index.vue?macro=true";
import { default as index1aL_l7RGzV9brsX4hmKSwkURa3q8eZRR1XTD0qyq8iQMeta } from "/home/runner/work/pornplus/pornplus/frontend/pages/members/channels/[slug]/[release]/pictures/index.vue?macro=true";
import { default as _91id_934NqhyCa1dlb5uNDkLpSO7eyk6j9NzY_3VF12mqhswSsMeta } from "/home/runner/work/pornplus/pornplus/frontend/pages/tour/image/images/[siteName]/[setName]/[imageName]/[id].vue?macro=true";
import { default as component_45stubUAiqCQ_ZPpFnVz9bw7DmDV8nNfbiWVS3CB9RQecHW1AMeta } from "/home/runner/work/pornplus/pornplus/frontend/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stubUAiqCQ_ZPpFnVz9bw7DmDV8nNfbiWVS3CB9RQecHW1A } from "/home/runner/work/pornplus/pornplus/frontend/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: "2257",
    path: "/2257",
    component: () => import("/home/runner/work/pornplus/pornplus/frontend/pages/2257.vue")
  },
  {
    name: "dmca",
    path: "/dmca",
    component: () => import("/home/runner/work/pornplus/pornplus/frontend/pages/dmca.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/home/runner/work/pornplus/pornplus/frontend/pages/index.vue")
  },
  {
    name: "terms",
    path: "/terms",
    component: () => import("/home/runner/work/pornplus/pornplus/frontend/pages/terms.vue")
  },
  {
    name: "privacy",
    path: "/privacy",
    component: () => import("/home/runner/work/pornplus/pornplus/frontend/pages/privacy.vue")
  },
  {
    name: "geo_test",
    path: "/geo_test",
    component: () => import("/home/runner/work/pornplus/pornplus/frontend/pages/geo_test.vue")
  },
  {
    name: "login-auto",
    path: "/login/auto",
    component: () => import("/home/runner/work/pornplus/pornplus/frontend/pages/login/auto.vue")
  },
  {
    name: "login",
    path: "/login",
    component: () => import("/home/runner/work/pornplus/pornplus/frontend/pages/login/index.vue")
  },
  {
    name: "sites",
    path: "/sites",
    component: () => import("/home/runner/work/pornplus/pornplus/frontend/pages/sites/index.vue")
  },
  {
    name: "models",
    path: "/models",
    component: () => import("/home/runner/work/pornplus/pornplus/frontend/pages/models/index.vue")
  },
  {
    name: "series",
    path: "/series",
    component: () => import("/home/runner/work/pornplus/pornplus/frontend/pages/series/index.vue")
  },
  {
    name: "sites-slug",
    path: "/sites/:slug()",
    component: () => import("/home/runner/work/pornplus/pornplus/frontend/pages/sites/[slug].vue")
  },
  {
    name: "video-slug",
    path: "/video/:slug()",
    component: () => import("/home/runner/work/pornplus/pornplus/frontend/pages/video/[slug].vue")
  },
  {
    name: "members",
    path: "/members",
    meta: {"middleware":["auth"]},
    component: () => import("/home/runner/work/pornplus/pornplus/frontend/pages/members/index.vue")
  },
  {
    name: "models-slug",
    path: "/models/:slug()",
    component: () => import("/home/runner/work/pornplus/pornplus/frontend/pages/models/[slug].vue")
  },
  {
    name: "series-slug",
    path: "/series/:slug()",
    component: () => import("/home/runner/work/pornplus/pornplus/frontend/pages/series/[slug].vue")
  },
  {
    name: "welcome",
    path: "/welcome",
    component: () => import("/home/runner/work/pornplus/pornplus/frontend/pages/welcome/index.vue")
  },
  {
    name: "content_removal",
    path: "/content_removal",
    component: () => import("/home/runner/work/pornplus/pornplus/frontend/pages/content_removal.vue")
  },
  {
    name: "tours-top-rated",
    path: "/tours/top-rated",
    component: () => import("/home/runner/work/pornplus/pornplus/frontend/pages/tours/top-rated.vue")
  },
  {
    name: "members-deals",
    path: "/members/deals",
    meta: {"middleware":["auth"]},
    component: () => import("/home/runner/work/pornplus/pornplus/frontend/pages/members/deals/index.vue")
  },
  {
    name: "members-sites",
    path: "/members/sites",
    meta: {"middleware":["auth"]},
    component: () => import("/home/runner/work/pornplus/pornplus/frontend/pages/members/sites/index.vue")
  },
  {
    name: "members-models",
    path: "/members/models",
    meta: {"middleware":["auth"]},
    component: () => import("/home/runner/work/pornplus/pornplus/frontend/pages/members/models/index.vue")
  },
  {
    name: "members-movies",
    path: "/members/movies",
    meta: {"middleware":["auth"]},
    component: () => import("/home/runner/work/pornplus/pornplus/frontend/pages/members/movies/index.vue")
  },
  {
    name: "members-offers",
    path: "/members/offers",
    meta: {"middleware":["auth"]},
    component: () => import("/home/runner/work/pornplus/pornplus/frontend/pages/members/offers/index.vue")
  },
  {
    name: "members-series",
    path: "/members/series",
    meta: {"middleware":["auth"]},
    component: () => import("/home/runner/work/pornplus/pornplus/frontend/pages/members/series/index.vue")
  },
  {
    name: "members-sites-slug",
    path: "/members/sites/:slug()",
    meta: {"middleware":["auth"]},
    component: () => import("/home/runner/work/pornplus/pornplus/frontend/pages/members/sites/[slug].vue")
  },
  {
    name: "members-account",
    path: "/members/account",
    meta: {"middleware":["auth"]},
    component: () => import("/home/runner/work/pornplus/pornplus/frontend/pages/members/account/index.vue")
  },
  {
    name: "members-models-slug",
    path: "/members/models/:slug()",
    meta: {"middleware":["auth"]},
    component: () => import("/home/runner/work/pornplus/pornplus/frontend/pages/members/models/[slug].vue")
  },
  {
    name: "members-series-slug",
    path: "/members/series/:slug()",
    meta: {"middleware":["auth"]},
    component: () => import("/home/runner/work/pornplus/pornplus/frontend/pages/members/series/[slug].vue")
  },
  {
    name: "members-upgrade",
    path: "/members/upgrade",
    meta: {"middleware":["auth"]},
    component: () => import("/home/runner/work/pornplus/pornplus/frontend/pages/members/upgrade/index.vue")
  },
  {
    name: "members-channels",
    path: "/members/channels",
    meta: {"middleware":["auth"]},
    component: () => import("/home/runner/work/pornplus/pornplus/frontend/pages/members/channels/index.vue")
  },
  {
    name: "members-favorites",
    path: "/members/favorites",
    meta: {"middleware":["auth"]},
    component: () => import("/home/runner/work/pornplus/pornplus/frontend/pages/members/favorites/index.vue")
  },
  {
    name: "members-categories",
    path: "/members/categories",
    meta: {"middleware":["auth"]},
    component: () => import("/home/runner/work/pornplus/pornplus/frontend/pages/members/categories/index.vue")
  },
  {
    name: "members-membership",
    path: "/members/membership",
    meta: {"middleware":["auth"]},
    component: () => import("/home/runner/work/pornplus/pornplus/frontend/pages/members/membership/index.vue")
  },
  {
    name: "members-notifications",
    path: "/members/notifications",
    meta: {"middleware":["auth"]},
    component: () => import("/home/runner/work/pornplus/pornplus/frontend/pages/members/notifications/index.vue")
  },
  {
    name: "members-subscriptions",
    path: "/members/subscriptions",
    meta: {"middleware":["auth"]},
    component: () => import("/home/runner/work/pornplus/pornplus/frontend/pages/members/subscriptions/index.vue")
  },
  {
    name: "members-channels-slug",
    path: "/members/channels/:slug()",
    meta: {"middleware":["auth"]},
    component: () => import("/home/runner/work/pornplus/pornplus/frontend/pages/members/channels/[slug]/index.vue")
  },
  {
    name: "members-age_verification",
    path: "/members/age_verification",
    meta: {"middleware":["auth"]},
    component: () => import("/home/runner/work/pornplus/pornplus/frontend/pages/members/age_verification/index.vue")
  },
  {
    name: "members-video-slug-section",
    path: "/members/video/:slug()/:section?",
    meta: {"middleware":["auth"]},
    component: () => import("/home/runner/work/pornplus/pornplus/frontend/pages/members/video/[slug]/[[section]].vue")
  },
  {
    name: "members-video-slug-pictures",
    path: "/members/video/:slug()/pictures",
    meta: {"middleware":["auth"]},
    component: () => import("/home/runner/work/pornplus/pornplus/frontend/pages/members/video/[slug]/pictures/index.vue")
  },
  {
    name: "members-channels-slug-release",
    path: "/members/channels/:slug()/:release()",
    meta: {"middleware":["auth"]},
    component: () => import("/home/runner/work/pornplus/pornplus/frontend/pages/members/channels/[slug]/[release]/index.vue")
  },
  {
    name: "members-channels-slug-release-pictures",
    path: "/members/channels/:slug()/:release()/pictures",
    meta: {"middleware":["auth"]},
    component: () => import("/home/runner/work/pornplus/pornplus/frontend/pages/members/channels/[slug]/[release]/pictures/index.vue")
  },
  {
    name: "tour-image-images-siteName-setName-imageName-id",
    path: "/tour/image/images/:siteName()/:setName()/:imageName()/:id()",
    component: () => import("/home/runner/work/pornplus/pornplus/frontend/pages/tour/image/images/[siteName]/[setName]/[imageName]/[id].vue")
  },
  {
    name: component_45stubUAiqCQ_ZPpFnVz9bw7DmDV8nNfbiWVS3CB9RQecHW1AMeta?.name,
    path: "/girls",
    component: component_45stubUAiqCQ_ZPpFnVz9bw7DmDV8nNfbiWVS3CB9RQecHW1A
  },
  {
    name: component_45stubUAiqCQ_ZPpFnVz9bw7DmDV8nNfbiWVS3CB9RQecHW1AMeta?.name,
    path: "/guys",
    component: component_45stubUAiqCQ_ZPpFnVz9bw7DmDV8nNfbiWVS3CB9RQecHW1A
  }
]